<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="error">delete</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Remove Animal</span>
      </v-card-title>
      <v-card-text>
        Do you really want to delete "{{animal.title}}"? Images and Posts will not be deleted.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.native="del()" :loading="loading">Löschen</v-btn>
        <v-btn color="primary" @click.native="dialog = false">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  // import { VueEditor } from 'vue2-editor';
  import { mapActions } from 'vuex';


  export default {
    name: 'DlgAnimalsDelete',
    components: {
      // VueEditor,
    },
    data() {
      return {
        dialog: false,
        loading: false,
      };
    },
    props: ['animal'],
    methods: {
      ...mapActions({
        memberDel: 'admin/animals/del',
        memberRead: 'admin/animals/read',
      }),
      del() {
        this.loading = true;
        this.memberDel(this.animal)
          .then((res) => {
            this.loading = false;
            if (res) {
              this.memberRead();
              this.dialog = false;
            }
          });
      },
    },
  };
</script>

<style scoped>

</style>
